import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Col, Row, View } from "@amzn/stencil-react-components/layout";
import { MessageBanner, MessageBannerType } from "@amzn/stencil-react-components/message-banner";
import { Spinner, SpinnerSize } from "@amzn/stencil-react-components/spinner";
import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";

export const StepSpinner: FC<{ testId: string }> = ({ testId }) => (
  <View display="flex" justifyContent="center" padding="S400" data-testid={testId}>
    <Spinner size={SpinnerSize.Medium} />
  </View>
);

export interface StepErrorProps {
  testId: string;
  message: string;
  onRetry?: () => void;
}

export const StepError: FC<StepErrorProps> = ({ testId, message, onRetry }) => (
  <Col gridGap="S300" width="100%" data-testid={testId}>
    <View width="100%">
      <MessageBanner type={MessageBannerType.Error} isDismissible={false}>
        {message}
      </MessageBanner>
    </View>
    {onRetry && (
      <Row width="100%" justifyContent="flex-end">
        <Button variant={ButtonVariant.Secondary} onClick={onRetry}>
          {getString("replacement.chooseDevice.tryAgain")}
        </Button>
      </Row>
    )}
  </Col>
);
